import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { setPersistedEndpointVersions, setShouldPersist } from '../apiMetaSlice'

export const useSetApiMetadata = () => {
  const dispatch = useDispatch()
  const { ppuiPersistedEndpointVersions, ppuiShouldPersistEndpoints } = useFlags()
  useEffect(() => {
    if (ppuiPersistedEndpointVersions) {
      dispatch(setPersistedEndpointVersions(ppuiPersistedEndpointVersions))
    }
  }, [dispatch, ppuiPersistedEndpointVersions])

  useEffect(() => {
    dispatch(setShouldPersist(ppuiShouldPersistEndpoints))
  }, [dispatch, ppuiShouldPersistEndpoints])
}
